import dynamic from 'next/dynamic';
import React from 'react';

const ClientComponent = (Component: React.FunctionComponent<any>) => dynamic(
    () => Promise.resolve(Component),
    { ssr: false },
);

export default ClientComponent;